<template>
    <div class="advertis">
        <div class="adv_pics">
            <!-- 广告1 -->
            <p v-if="Loading" style="text-align: center;height: 110px;line-height: 110px;"><mt-spinner type="triple-bounce"></mt-spinner></p>
            <div class="column_adv" @click.stop="advertisingThree(advertisingLists.advertUrl)">
                <div style="display:block;height:110px">
                    <span class="column_adver">广告</span>
                    <!-- <el-image :src="'http://121.36.11.76:9503' + advertisingLists.imgPath" lazy></el-image> -->
                    <img :src="'https://www.pyxxww.com:29503' + advertisingLists.imgPath" alt="">
                </div>
            </div>
            <!-- 广告2 -->
            <p v-if="Loadings" style="text-align: center;height: 360px;line-height: 360px;"><mt-spinner type="triple-bounce"></mt-spinner></p>
            <div class="advPicsTwo">
                <!-- <div class="advpic_left">
                    <img src="../images/pic5.png" alt="">
                    <span>风景名胜</span>
                </div>
                <div class="advpic_center">
                    <img src="../images/pic6.png" alt="">
                    <span>濮阳文化</span>
                </div>
                <div class="advpic_right">
                    <div class="advpic_right_top">
                        <img src="../images/pic3.png" alt="">
                        <span>濮阳房产</span>
                    </div>
                    <div class="advpic_right_bto">
                        <img src="../images/pic4.png" alt="">
                        <span>濮阳美食</span>
                    </div>
                </div> -->

                <el-carousel :interval="3000" type="card" height="360px" indicator-position="outside">
                    <el-carousel-item class="pic_list_advertising" v-for="(item,index) in picAdvertisingLists" :key="index">
                        <div style="text-align: center;width:100%;height:100%;display:block"  @click.stop="advertisingThree(item.advertUrl)">
                            <!-- <el-image :src="'http://121.36.11.76:9503' + item.imgPath" lazy></el-image> -->
                            <img :src="'https://www.pyxxww.com:29503' + item.imgPath" alt="">
                            <p class="pic_advertName">{{item.advertName}}</p>
                        </div>
                    </el-carousel-item>
                </el-carousel>
            </div>
        </div>
    </div>
</template>
<script>
import {advertisingList,generateSign} from '@/api/index'

const advertisingParameter = {
    appInfoId:10,
    pageNo:1,
    pageSize:10
}
export default {
    data(){
        return {
            Loading:true,
            Loadings:true,
            listParameter: Object.assign({}, advertisingParameter),
            advertisingLists:[],
            picAdvertisingLists:[],
            moduleDifferentiation:[]
        }
    },
    created(){
        this.advertisingListFun()
    },
    methods: {
        advertisingListFun(){
            const headers = {
        'Sign': generateSign()
      };
            this.axios.post(advertisingList,this.listParameter).then(res => {
                this.advertisingLists = res.data.data[0][3][0]
                this.Loading = false
                this.picAdvertisingLists = res.data.data[0][4]
                this.Loadings = false
            })
        },
        advertisingThree(newHref){
            window.open(newHref,'_blank')
        }
    },
}
</script>
<style lang="">
    .pic_list_advertising img{
        width:100%;
        height:100%;
        background:#fff;
    }
    .pic_advertName{
        position: absolute;
        height:60px;
        width:100%;
        color:#fff;
        font-size: 18px;
        line-height:60px;
        text-align: center;
        background:rgba(0,0,0,0.5);
        bottom:0;
    }
    .adv_pics{
        height:570px;
    }
    .adv_pics .column_adv{
        height:110px;
        position:relative;
    }
    .adv_pics .column_adv .column_adver{
        background:rgba(255,255,255,0.1);
        position:absolute;
        height:22px;
        border:1px solid #FFFFFF;
        color:#FFFFFF;
        bottom:12px;
        left:16px;
        border-radius: 5px;
        font-size: 12px;
        line-height: 22px;
        padding:0 10px;
    }
    .adv_pics .column_adv img{
        width:100%;
        height:110px;
    }
    .advPicsTwo{
        height:360px;
        margin:50px 0;
    }
    .advPicsTwo .advpic_left{
        width:480px;
        height:360px;
        float:left;
        position:relative;
    }
    .advPicsTwo .advpic_left img{
        width:100%;
        height:100%;
    }
    .advPicsTwo .advpic_left span{
        position:absolute;
        left:0;
        top:47px;
        font-weight:bold;
        color:rgba(255,255,255,1);
        font-size:30px;
        background:rgba(54,107,0,0.8);
        width:178px;
        height:64px;
        line-height:64px;
        text-align: center;
    }
    .advPicsTwo .advpic_center{
        width:280px;
        height:360px;
        float:left;
        position:relative;
    }
    .advPicsTwo .advpic_center img{
        width:100%;
        height:100%;
    }
    .advPicsTwo .advpic_center span{
        background:rgba(255,145,2,0.8);
        width:140px;
        height:50px;
        text-align: center;
        line-height:50px;
        font-size:20px;
        font-weight: bolder;
        color:#FFFFFF;
        position:absolute;
        left:0;
        bottom:34px;
    }
    .advPicsTwo .advpic_right{
        width:438px;
        height:360px;
        float:left;
        position:relative;
        background:blue;

    }
    .advPicsTwo .advpic_right .advpic_right_top{
        width:438px;
        height:180px;
        position:relative;
    }
    .advPicsTwo .advpic_right .advpic_right_top img{
        width:100%;
        height:100%;
    }
    .advPicsTwo .advpic_right .advpic_right_top span{
        width:140px;
        height:50px;
        background:rgba(12,69,150,0.8);
        color:#FFFFFF;
        font-size:20px;
        position:absolute;
        top:29px;
        right:0;
        font-weight: bold;
        line-height:50px;
        text-align: center;
    }
    .advPicsTwo .advpic_right .advpic_right_bto{
        width:438px;
        height:180px;
        position:relative;
    }
    .advPicsTwo .advpic_right .advpic_right_bto img{
        width:100%;
        height:100%;
    }
    .advPicsTwo .advpic_right .advpic_right_bto span{
        width:140px;
        height:50px;
        background:rgba(188,25,26,0.8);
        color:#FFFFFF;
        font-size:20px;
        position:absolute;
        top:29px;
        right:0;
        font-weight: bold;
        line-height:50px;
        text-align: center;
    }
</style>


// WEBPACK FOOTER //
// src/components/homepage/components/advertising.vue